import React from "react";
import "./hero-banner.css";

const HeroBanner = () => {
  return (
    <section
      className="hero-banner"
      // style={{ backgroundImage: "url('/public/banner-bg.png')" }}
    >
      <div className="overlay"></div>
      <div className="hero-content">
        <h1>
          Brewed Fresh, <br /> Served With Love
        </h1>
        <p>
          Wake up to the scent of freshly made coffee, a relaxing atmosphere,
          and delicious food - your ideal cafe moment awaits.
        </p>
        <a href="/view-our-menu" className="view-more-btn">
          Order Now
        </a>
      </div>
    </section>
  );
};

export default HeroBanner;
